import { onlyDigits } from './formatting';

export const isValidBrazilPhone = (value: string) => {
    const digits = onlyDigits(value);
    return digits.length === 11;
};

export const isValidEmail = (value: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const isValidCPF = (cpfMasked: string) => {
    const cpf = onlyDigits(cpfMasked);
    if (cpf.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(cpf)) return false;
    let sum = 0;
    for (let i = 0; i < 9; i++) sum += parseInt(cpf[i], 10) * (10 - i);
    let d1 = (sum * 10) % 11;
    if (d1 === 10) d1 = 0;
    if (d1 !== parseInt(cpf[9], 10)) return false;
    sum = 0;
    for (let i = 0; i < 10; i++) sum += parseInt(cpf[i], 10) * (11 - i);
    let d2 = (sum * 10) % 11;
    if (d2 === 10) d2 = 0;
    return d2 === parseInt(cpf[10], 10);
};

export const isValidCNPJ = (cnpjMasked: string) => {
    const cnpj = onlyDigits(cnpjMasked);
    if (cnpj.length !== 14) return false;
    if (/^(\d)\1{13}$/.test(cnpj)) return false;

    const calcDigit = (len: number) => {
        const weights = len === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        let sum = 0;
        for (let i = 0; i < weights.length; i++) sum += parseInt(cnpj[i], 10) * weights[i];
        const mod = sum % 11;
        return mod < 2 ? 0 : 11 - mod;
    };

    const d1 = calcDigit(12);
    if (d1 !== parseInt(cnpj[12], 10)) return false;
    const d2 = calcDigit(13);
    return d2 === parseInt(cnpj[13], 10);
};

export const isValidCpfOrCnpj = (v: string) => {
    const digits = onlyDigits(v);
    if (digits.length <= 11) return isValidCPF(v);
    return isValidCNPJ(v);
};
